module.exports = __webpack_public_path__ + "img/fear-and-greed-light.0cdd32e.png";